import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

export type Edition = 'free' | 'standard' | 'premium' | 'enterprise';

export type EditionMetaResponse = {
	beta: boolean;
	canSelfServe: boolean;
	edition: Edition;
	enforcePermissionChecksEnabledOnSite: boolean;
	selfServeEnabledOnSite: boolean;
	siteCreator: boolean;
};

export const getEditionMeta = (): Promise<EditionMetaResponse> =>
	fetchJson('/rest/polaris/edition?operation=getEditionMeta');
